module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "display": "inline-block"
    }
  }, [(_vm.show && _vm.mode != 'first') ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {}, [_vm._v("Erlöse anzeigen")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showUE == 1
    },
    on: {
      "click": function($event) {
        _vm.showUE = 1;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" An\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showUE == 0
    },
    on: {
      "click": function($event) {
        _vm.showUE = 0;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Aus\r\n            ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {}, [_vm._v("Modus")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.modus == ''
    },
    on: {
      "click": function($event) {
        _vm.modus = '';
        _vm.closeSettings();
        _vm.resetSearch();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Alle\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.modus == 'top'
    },
    on: {
      "click": function($event) {
        _vm.modus = 'top';
        _vm.closeSettings();
        _vm.resetSearch();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" TOP 5\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.modus == 'flop'
    },
    on: {
      "click": function($event) {
        _vm.modus = 'flop';
        _vm.closeSettings();
        _vm.resetSearch();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" FLOP 5\r\n            ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {}, [_vm._v("Vergleich")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.period == 'vormonat' || _vm.period == ''
    },
    on: {
      "click": function($event) {
        _vm.period = 'vormonat';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Periode\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.period == 'jahr'
    },
    on: {
      "click": function($event) {
        _vm.period = 'jahr';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Ganzes Jahr\r\n            ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.modus == '') ? _c('p', {}, [_vm._v("Sortierung")]) : _vm._e(), _vm._v(" "), (_vm.modus == '') ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.sort == 'alpha' || _vm.sort == ''
    },
    on: {
      "click": function($event) {
        _vm.sort = 'alpha';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Alphabetisch\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.sort == 'revenues'
    },
    on: {
      "click": function($event) {
        _vm.sort = 'revenues';
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Nach Umsatz\r\n            ")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.mode == 'first') ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "link text-right closeBtn",
    on: {
      "click": function($event) {
        _vm.closeSettings();
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {}, [_vm._v("Erlöse / Gewinnspannen")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showEG == 1
    },
    on: {
      "click": function($event) {
        _vm.showEG = 1;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" An\r\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.showEG == 0
    },
    on: {
      "click": function($event) {
        _vm.showEG = 0;
        _vm.closeSettings();
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Aus\r\n            ")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "settingsOpener",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d56d485","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/Dashboard/Settings.html
// module id = 557
// module chunks = 1